import React from 'react';

function SkillBasedGroups(props) {
    return (
        <div></div>
    );
}

export default SkillBasedGroups;